import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";
import { handleApiError } from "../config/errorHandler";

/**
 * Fetch catering order details by order ID
 * @param {string|number} orderId - Order ID
 * @param {string} isCombineOrder - Whether it's a combined order ("yes" or "no")
 * @returns {Promise<Object>} - Response data from the API
 */
export const getCateringOrderDetailsApi = async (orderId, isCombineOrder = "no") => {
  try {
    const endpoint = API_ENDPOINTS.CATERING_ORDER_DETAILS.replace(':orderId', orderId);
    const response = await apiClient.get(endpoint, {
      params: {
        is_combine_order: isCombineOrder
      }
    });
    return response.data; // Return the fetched data
  } catch (error) {
    handleApiError(error); // Handle API errors centrally
    throw error;
  }
};
